export default class CollectionFilter {
  constructor(limit, page) {
    this.resetConnections();
    this.resetSort();
    this.resetSearch();
    this.resetDefaultSort();
    this.resetFilters();
    this.resetStaticFilters();
    this.resetCustomFilters();
    this.setPage(page);
    this.setLimit(limit);
  }
  cacheStaticFilters() {
    if (!Array.isArray(this.static_filters) || !this.static_filters.length) {
      this.static_filters = [...this.filters];
      this.resetFilters();
    }

    return this;
  }
  resetConnections() {
    this.connections = [];

    return this;
  }
  resetFilters() {
    this.filters = [];

    return this;
  }
  resetStaticFilters() {
    this.static_filters = [];

    return this;
  }
  resetCustomFilters() {
    this.custom_filters = [];

    return this;
  }
  resetSearch() {
    this.search = null;

    return this;
  }
  resetSort() {
    this.sort = [];

    return this;
  }
  resetDefaultSort() {
    this.default_sort = [];

    return this;
  }
  getQuery() {
    return this.getQueryComponents().join("&");
  }
  getQueryComponents() {
    const components = [];
    const filters = this.mergeFilters();
    const sort = this.mergeSort();

    if (this.connections.length) {
      this.connections.forEach((value) => {
        components.push(`connection[]=${value.connection}`);
      });
    }

    if (this.search) {
      components.push(`search=${this.search}`);
    }

    if (filters.length) {
      filters.forEach((value) => {
        components.push(
          `filter[]=${[
            value.field,
            value.operator,
            value.value,
            value.logic,
          ].join(":")}`
        );
      });
    }

    if (sort.length) {
      sort.forEach((value) => {
        components.push(`sort[]=${[value.field, value.order].join(":")}`);
      });
    }

    if (this.custom_filters.length) {
      this.custom_filters.forEach((i) => {
        components.push(`custom_filter[${i.key}]=${i.value}`);
      });
    }

    if (this.getLimit()) {
      components.push(`limit=${this.getLimit()}`);
    }

    if (this.getPage()) {
      components.push(`page=${this.getPage()}`);
    }

    return components;
  }
  setLimit(limit) {
    this.limit = limit;

    return this;
  }
  getLimit() {
    return this.limit;
  }
  setPage(page) {
    this.page = parseInt(page);

    return this;
  }
  getPage() {
    return parseInt(this.page);
  }
  searchAdd(search_value) {
    this.search = search_value;

    return this;
  }
  filterAdd(field, operator, value, logic) {
    logic = logic ? logic.toLowerCase().trim() : null;

    switch (logic) {
      case "or":
      case "whereor":
      case "orwhere":
        logic = "OrWhere";
        break;
      case "and":
      case "where":
      case "whereand":
      default:
        logic = "where";
        break;
    }

    if (Array.isArray(value)) {
      value = value.join("|");
    }

    const filter = {
      field: field,
      operator: operator,
      value: value,
      logic: logic,
    };

    this.filters.push(filter);

    return this;
  }
  filterContains(field, value, logic) {
    return this.filterAdd(field, "ct", value, logic);
  }
  filterNotContains(field, value, logic) {
    return this.filterAdd(field, "nct", value, logic);
  }
  filterStarts(field, value, logic) {
    return this.filterAdd(field, "sw", value, logic);
  }
  filterEnds(field, value, logic) {
    return this.filterAdd(field, "ew", value, logic);
  }
  filterEquals(field, value, logic) {
    return this.filterAdd(field, "eq", value, logic);
  }
  filterNotEquals(field, value, logic) {
    return this.filterAdd(field, "ne", value, logic);
  }
  filterGreater(field, value, logic) {
    return this.filterAdd(field, "gt", value, logic);
  }
  filterGreaterEqual(field, value, logic) {
    return this.filterAdd(field, "ge", value, logic);
  }
  filterLess(field, value, logic) {
    return this.filterAdd(field, "le", value, logic);
  }
  filterLessEqual(field, value, logic) {
    return this.filterAdd(field, "le", value, logic);
  }
  filterIn(field, array, logic) {
    return this.filterAdd(field, "in", array, logic);
  }
  filterNotIn(field, array, logic) {
    return this.filterAdd(field, "nin", array, logic);
  }
  filterNull(field, logic) {
    return this.filterAdd(field, "null", null, logic);
  }
  filterNotNull(field, logic) {
    return this.filterAdd(field, "nnull", null, logic);
  }
  filterHas(connection, logic) {
    return this.filterAdd(connection, "has", null, logic);
  }
  defaultSortAdd(field, order) {
    order = order.toUpperCase().trim();

    switch (order) {
      case "ASC":
      case "DESC":
        break;
      default:
        order = "ASC";
        break;
    }

    const filter = {
      field: field,
      order: order,
    };

    this.default_sort.push(filter);

    return this;
  }
  defaultSortAddAsc(field) {
    return this.defaultSortAdd(field, "ASC");
  }
  defaultSortAddDesc(field) {
    return this.defaultSortAdd(field, "DESC");
  }
  sortAdd(field, order, default_sort) {
    order = order.toUpperCase().trim();

    switch (order) {
      case "ASC":
      case "DESC":
        break;
      default:
        order = "ASC";
        break;
    }

    const filter = {
      field: field,
      order: order,
    };

    if (default_sort === true) {
      this.default_sort.push(filter);
    } else {
      this.sort.push(filter);
    }

    return this;
  }
  sortAddAsc(field, default_sort) {
    return this.sortAdd(field, "ASC", default_sort);
  }
  sortAddDesc(field, default_sort) {
    return this.sortAdd(field, "DESC", default_sort);
  }
  connectionAdd(table) {
    if (!this.connectionExists(table)) {
      this.connections.push({
        connection: table,
      });
    }
  }
  connectionExists(table) {
    let result = false;

    this.connections.forEach((obj) => {
      if (obj.connection === table) {
        result = true;
      }
    });

    return result;
  }
  mergeFilters() {
    if (!Array.isArray(this.static_filters) || !this.static_filters.length) {
      return this.filters;
    }

    return this.static_filters.concat(this.filters);
  }
  mergeSort() {
    if (!Array.isArray(this.sort) || !this.sort.length) {
      return this.default_sort;
    }

    return this.sort;
  }
  customFilterAdd(key, value) {
    this.custom_filters.push({ key, value });
  }
}
